export default {
    nativeBridge: undefined,
}